import React, { useState, useEffect } from 'react';
import CTGListContent from './CTGListContent';

const AllCTGList = () => {
	const [loading, setLoading] = useState(false);

  const [ctgList, setCTGList] = useState(null);
  // const [openNewStudyModal, setOpenNewStudyModal] = useState(false);
  // const [openDeleteModal, setOpenDeleteModal] = useState(false);
  // const [deleteItem, setDeleteItem] = useState(null);
  // const [openSyncModal,setOpenSyncModal] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [openExportModal, setOpenExportModal] = useState(false);
  useEffect(() => {

  }, [])

  return(
    <CTGListContent
      ctgList={ctgList}
      // setOpenNewStudyModal={setOpenNewStudyModal}
      // onDeleteClicked={showDeleteConfirm}
      // onSyncClicked={showSyncConfirm}
      // onExportClicked={showExportConfirm}
      refresh={refreshData}
      setRefresh={setRefreshData}
      />
  )
} 
export default AllCTGList